export const text = {
  noteTitle: {
    fontWeight: 'extrabold',
    fontSize: 9,
    mb: 3,
    lineHeight: 'none',
    display: 'flex',
    alignItems: 'center',
    color: 'textStrong',
  },

  noteListItem: {
    position: 'relative',
    fontSize: 2,
    m: 0,
    fontFamily: 'body',
    fontWeight: 'bold',
    color: 'textStrong',
    pl: 5,
  },

  dateModified: {
    fontSize: 0,
    color: 'text',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}
